import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useAxios, useApiResponseParser } from "../";
import { ACCENT_COLORS_QUERY_KEY } from "../useAccentColors";

export default function useColors() {
    const { axiosPrivate } = useAxios();
    const { parseSuccessResponseData } = useApiResponseParser();
    const queryClient = useQueryClient();

    const invalidate = () =>
        queryClient.invalidateQueries({ queryKey: ACCENT_COLORS_QUERY_KEY });

    function useList() {
        return useMutation({
            mutationFn: () =>
                axiosPrivate.get(`/v1/colors/list`).then(parseSuccessResponseData),
        });
    }

    function useCreate() {
        return useMutation({
            mutationFn: (parameters: any) =>
                axiosPrivate
                    .post(`/v1/colors/create`, parameters)
                    .then(parseSuccessResponseData),
            onSuccess: invalidate,
        });
    }

    function useUpdate() {
        return useMutation({
            mutationFn: (parameters: any) =>
                axiosPrivate
                    .post(`/v1/colors/update`, parameters)
                    .then(parseSuccessResponseData),
            onSuccess: invalidate,
        });
    }

    function useDelete() {
        return useMutation({
            mutationFn: (parameters: any) =>
                axiosPrivate
                    .delete(`/v1/colors/delete/${parameters.id}`)
                    .then(parseSuccessResponseData),
            onSuccess: invalidate,
        });
    }

    return { useList, useCreate, useUpdate, useDelete };
}
